import { get } from "lodash";
import * as CONSTANTS from "../../constants";

const initialState = {
  isLoading: false,
  errors: null,
  changePasswordData: {
    data: null,
  },
  validateChangePasswordToken: {
    data: null,
  },
}

export default function (state = initialState, action) {
  switch (action.type) {
    case CONSTANTS.UPDATE_CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        isLoading: action.payload,
        errors: null,
        changePasswordData: {
          data: null,
        },
      }
    case CONSTANTS.UPDATE_CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errors: null,
        changePasswordData: {
          data: action.payload,
        },
      }
    case CONSTANTS.UPDATE_CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
        changePasswordData: {
          data: null,
        },
      }
    case CONSTANTS.CHANGE_PASSWORD_TOKEN_VALID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errors: null,
        validateChangePasswordToken: {
          data: action.payload,
        },
      }
    case CONSTANTS.CHANGE_PASSWORD_TOKEN_VALID_ERROR:
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
        validateChangePasswordToken: {
          data: null,
        },
      }
    default:
      return state;
  }
}

export const getIsLoading = (state) => get(state, 'changePassword.isLoading');
export const getUpdatedChangePasswordSuccess = (state) => get(state, 'changePassword.changePasswordData.data');
export const getUpdatedChangePasswordErrors = (state) => get(state, "changePassword.errors.response.data.error.message.value");
export const getValidateChangePasswordTokenSuccess = (state) => get(state, 'changePassword.validateChangePasswordToken.data');